export const environment = {
  baseUrl: 'https://edufundapi.ta2ng.com',
  // baseUrl: 'https://lottery-backend-te6x.onrender.com',
  // baseUrl: 'http://localhost:3000',
  xapikey: 'EDULOTTFOROPEN',
};
